import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const getDefaultServer = () => {
    const currentPath = location.pathname.split('/')[1];
    
    if (currentPath && !isNaN(currentPath) && currentPath >= 1 && currentPath <= 5) {
      return `https://radio.amgroupmkt.com:1030/api/v2/servers/${currentPath}/`;
    }
    
    return 'https://radio.amgroupmkt.com:1030/api/v2/servers/3/';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const result = await login(credentials.username, credentials.password);
      console.log(result);
      if (result.success) {
        if (result.userData.level !== "0") {
          console.log('Usuario nivel 1 o 2, permitiendo acceso');
          navigate(result.redirectPath);
          
        } else {
          console.log('Usuario nivel 0, permitiendo acceso');
          
        }
      } else {
        toast.error(result.message || 'Usuario o contraseña incorrectos', {
          autoClose: 3000
        });
      }
    } catch (error) {
      console.error('Error en login:', error);
      toast.error('Error al iniciar sesión', {
        autoClose: 3000
      });
    } finally {
      setIsLoading(false);
    }
  };

  const loginAsGuest = async () => {
    setIsLoading(true);
    try {
      const serverUrl = getDefaultServer();
      const result = await login('usuario_externo', 'contrasena', serverUrl);
      
      if (result.success) {
        toast.success('¡Bienvenido!', {
          onClose: () => {
            if (location.pathname === '/') {
              navigate(result.redirectPath);
            }
          }
        });
      } else {
        toast.error(result.message || 'Error al iniciar como invitado', {
          autoClose: 3000
        });
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Error al iniciar sesión', {
        autoClose: 3000
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      
      <div className="login-card">
        <img 
          src={require('../assets/AM GROUP Logo2.png')} 
          alt="AM Group Logo" 
          className="login-logo"
        />
        <div className="login-header">
          <h2>Iniciar Sesión</h2>
          <p>Sistema de Radio AM Group</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>
              <i className="fas fa-user"></i>
              <input
                type="text"
                placeholder="Usuario"
                value={credentials.username}
                onChange={(e) => setCredentials({
                  ...credentials,
                  username: e.target.value
                })}
                required
              />
            </label>
          </div>

          <div className="form-group">
            <label>
              <i className="fas fa-lock"></i>
              <input
                type="password"
                placeholder="Contraseña"
                value={credentials.password}
                onChange={(e) => setCredentials({
                  ...credentials,
                  password: e.target.value
                })}
                required
              />
            </label>
          </div>

          <button 
            type="submit" 
            className={`login-button ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="spinner"></span>
            ) : (
              <>
                <i className="fas fa-sign-in-alt"></i>
                Ingresar
              </>
            )}
          </button>

          {!location.pathname.endsWith('/verdeverdad') && (
            <button 
              type="button"
              onClick={loginAsGuest}
              className="login-button guest"
              disabled={isLoading}
            >
              <i className="fas fa-user-circle"></i>
              Sucursal sin registro
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default Login; 